import React from 'react';
import {
  Input, DatePicker, Row, Col,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';
import { Controller, useForm } from 'react-hook-form';
import 'react-toastify/dist/ReactToastify.css';
import AlumlyButton from '../../../components/AlumlyButton';
import { InputFormatEnum } from '../../../enums/inputFormat';
import { DateTimeUtils } from '../../../utils/dateTime';

export type FilterNotificationT = {
  searchQuery: string,
  dateCreated: Date,
};

interface FormFilterNotificationListProps {
  resetPage: Function;
  selectedFilter: FilterNotificationT | undefined;
  setSelectedFilter: React.Dispatch<React.SetStateAction<any>>;
}

const FormFilterNotificationList: React.FC<FormFilterNotificationListProps> = (props) => {
  const { selectedFilter, setSelectedFilter, resetPage } = props;

  const [isExpandFilter, setIsExpandFilter] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');

  const { control, reset } = useForm<{ searchQuery: string; dateCreated: Dayjs | null }>({
    defaultValues: {
      searchQuery: '',
      dateCreated: null,
    },
  });

  const handleSearch = (searchQuery: string): void => {
    if (searchQuery.length % 3 === 0) {
      setSelectedFilter({ ...selectedFilter, searchQuery });
      resetPage();
    }
  };

  const resetSearchAndFilter = (): void => {
    reset();
    setSelectedFilter({
      searchQuery: undefined,
      dateCreated: undefined,
    });
  };

  return (
    <div style={{ padding: '16px 0', marginTop: 24, background: 'white' }}>
      <Row gutter={16} align="middle">
        <Col xs={24} md={16}>
          <Controller
            name="searchQuery"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Input
                allowClear
                size="large"
                prefix={<SearchOutlined style={{ color: '#A1A1AA' }} />}
                placeholder="Search by Title, Message"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  handleSearch(e.target.value);
                  setSearchValue(e.target.value);
                }}
              />
            )}
          />
        </Col>
        <Col xs={12} md={4}>
          <AlumlyButton
            fullWidth
            onClick={() => setSelectedFilter({ ...selectedFilter, searchValue })}
          >
            Search
          </AlumlyButton>
        </Col>
        <Col xs={12} md={4}>
          <AlumlyButton
            label="rxvWhite"
            fullWidth
            onClick={() => setIsExpandFilter(!isExpandFilter)}
          >
            Filters
          </AlumlyButton>
        </Col>
      </Row>

      {isExpandFilter && (
        <Row gutter={16} align="middle" style={{ marginTop: 16 }}>
          <Col xs={24} md={6}>
            <Controller
              name="dateCreated"
              control={control}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  style={{ width: '100%' }}
                  size="large"
                  format={InputFormatEnum.date.format}
                  placeholder="Date created"
                  value={value}
                  onChange={(date) => {
                    onChange(date);
                    setSelectedFilter({
                      ...selectedFilter,
                      dateCreated: DateTimeUtils.dateFormat(date?.toDate() || undefined),
                    });
                    resetPage();
                  }}
                />
              )}
            />
          </Col>
          <Col xs={24} md={18} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ width: 184 }}>
              <AlumlyButton fullWidth onClick={resetSearchAndFilter}>
                Reset filters
              </AlumlyButton>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default FormFilterNotificationList;
